/*
 * Filename: ls-template-store.ts
 * Description: this file act as a store to save data of templates.
 */

import { CQTemplateListModel } from './models';

/** 
 * @description App Store Creation
 */
export const LSTemplatesStore = CQTemplateListModel.create({
    templates:[]
});

export type ILSTemplateStore = typeof CQTemplateListModel.Type;
